import React, { useState, useEffect } from "react";
import { apiservice } from "../service/api";
import {
  db,
  collection,
  getDocs,
  query,
  orderBy,
  addDoc,
  deleteDoc,
  Timestamp,
  where,
} from "../utils/firebase/firebase";
import { Image } from "react-native";
import { useRecoilState } from "recoil";
import { univer } from "../reducer";

const Chat = ({ universityId }) => {
  const [rooms, setRooms] = useState([]);
  const [selectedRoom, setSelectedRoom] = useState(null);
  const [university, setUniversity] = useRecoilState(univer);
  const [messages, setMessages] = useState([]);
  const [newMessage, setNewMessage] = useState("");
  const [searchTerm, setSearchTerm] = useState(""); // Search term state
  const currentUser = "User1"; // Replace with actual user info 

  useEffect(() => {
    const fetchRooms = async () => {
      const res = await apiservice({
        path: "/room/rooms/university?id=" + university.id,
        method: "get",
      });
      if (res.status === 200) {
        setRooms(res.data.rooms.sort((a, b) => a.name.localeCompare(b.name)));
      }
    };
    fetchRooms();
  }, [universityId]);

  const fetchMessages = async (roomId) => {
    const roomMessages = [];

    const messagesQuery = query(
      collection(db, "rooms", `${roomId}`, "messages"),
      orderBy("timestamp")
    );

    const messagesSnapshot = await getDocs(messagesQuery);

    messagesSnapshot.forEach((doc) => {
      const messageData = doc.data();
      roomMessages.push({
        id: doc.id,
        text: messageData.text,
        fileUrl: messageData.fileUrl,
        sender: messageData.sender,
        timestamp: messageData.timestamp.toDate(),
      });
    });

    setMessages(roomMessages);
  };

  const selectRoom = (room) => {
    setSelectedRoom(room);
    fetchMessages(room.id);
  };

  const sendMessage = async () => {
    if (!selectedRoom || !newMessage.trim()) return;

    const newMessageData = {
      text: newMessage,
      sender: currentUser,
      timestamp: Timestamp.now(),
    };

    await addDoc(collection(db, "rooms", selectedRoom.id, "messages"), newMessageData);

    setNewMessage("");
    fetchMessages(selectedRoom.id);
  };

  const deleteMessage = async (selectMessage) => {
    if (!selectedRoom || !selectMessage) return;

    // Get the messages collection 

    const messagesRef = collection(db, 'rooms', `${selectedRoom?.id}`, 'messages');

    if (selectMessage.text) {
      // Query for the specific message
      const q = query(
        messagesRef,
        where('text', '==', selectMessage.text),
        where('sender', '==', selectMessage.sender),
        where('timestamp', '==', Timestamp.fromDate(selectMessage.timestamp))
      );

      const snapshot = await getDocs(q);

      // Delete the first matching message
      if (!snapshot.empty) {
        await deleteDoc(snapshot.docs[0].ref);
      }
    }

    // Refresh messages
    fetchMessages(selectedRoom?.id);
    deleteMessageImage(selectMessage);
  };

  const deleteMessageImage = async (selectMessage) => {
    if (!selectedRoom || !selectMessage) return;

    // Get the messages collection 

    const messagesRef = collection(db, 'rooms', `${selectedRoom?.id}`, 'messages');


    // Query for the specific message
    const q = query(
      messagesRef,
      where('fileUrl', '==', selectMessage.fileUrl),
      where('sender', '==', selectMessage.sender),
      where('timestamp', '==', Timestamp.fromDate(selectMessage.timestamp))
    );

    const snapshot = await getDocs(q);

    // Delete the first matching message
    if (!snapshot.empty) {
      await deleteDoc(snapshot.docs[0].ref);
    }

    // Refresh messages
    fetchMessages(selectedRoom?.id);
  };

  function getOtherProfile(id) {
    return (
      rooms
        ?.find((item) => item.id === selectedRoom?.id)
        ?.members.map((item) => (item.infoModelId === id ? item : null))
        .filter((item) => item)?.[0] ?? null
    );
  }

  // Filter rooms based on search term
  const filteredRooms = rooms.filter((room) =>
    room.name.toLowerCase().includes(searchTerm.toLowerCase())
  );

  return (
    <div style={{ display: "flex", height: "calc(100vh - 65px)", width: "100%" }}>
      {/* Sidebar */}
      <div style={{ width: 355, backgroundColor: "#ccc", padding: "16px", overflow: "auto" }}>
        <h2 style={{ fontSize: "1.25rem", fontWeight: "bold" }}>Chat Rooms</h2>

        {/* Search input */}
        <input
          type="text"
          placeholder="Search rooms"
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          style={{
            width: "90%",
            padding: "8px",
            marginBottom: "16px",
            borderRadius: "4px",
            border: "1px solid #ccc",
          }}
        />

        {filteredRooms.length === 0 ? (
          <p>No rooms found</p>
        ) : (
          filteredRooms.map((room) => (
            <button
              key={room.id}
              style={{
                borderWidth: 0,
                width: "100%",
                textAlign: "left",
                padding: "8px",
                marginBottom: "8px",
                backgroundColor: "#f4f4f4",
                borderRadius: "4px",
                cursor: "pointer",
                display: "flex",
                alignItems: "center",
                gap: "10px",
              }}
              onClick={() => selectRoom(room)}
            >
              <Image style={{ width: 40, height: 40, borderRadius: 40 }} source={room?.groupInfo?.image_url?.[0]} />
              <div>
                <h2 style={{ fontSize: 12 }}>{room.name}</h2>
                {"สมาชิก"} {room.members.length} {"คน"}
              </div>
            </button>
          ))
        )}
      </div>

      {/* Chat Window */}
      <div style={{ width: "calc(100%)", padding: "16px" }}>
        {selectedRoom ? (
          <div>
            <h2 style={{ fontSize: "1.5rem", fontWeight: "600" }}>
              Room: {rooms.find((item) => item.id === selectedRoom.id)?.name}
            </h2>

            {/* Messages */}
            <div style={{
              marginTop: "16px",
              height: "calc(100vh - 205px)",
              overflowY: "auto",
              border: "1px solid",
              padding: "16px",
              borderRadius: "8px",
              backgroundColor: "#f3f4f6",
            }}>
              {messages.map((message) => (
                <div
                  key={message.id}
                  style={{
                    marginBottom: 8,
                    display: "flex",
                    justifyContent: message.sender === currentUser ? "flex-end" : "flex-start",
                    width: "100%",
                  }}
                >
                  {message.sender !== currentUser ? (
                    <div style={{ display: "flex", alignItems: "center", gap: "12px", width: '60%' }}>
                      <img
                        src={getOtherProfile(message.sender)?.image_url?.[0]}
                        alt="Profile"
                        style={{ width: "40px", height: "40px", borderRadius: "50%" }}
                      />
                      <div style={{ padding: "8px", backgroundColor: "#e5e7eb", borderRadius: "8px", width: '60%' }}>
                        <p>{message.text}</p>
                        {message.fileUrl && <img
                          src={message.fileUrl}
                          alt="Profile"
                          style={{ width: "100%", height: "50%" }}
                        />}
                        <p style={{ fontSize: "0.875rem", color: "#6b7280" }}>
                          {new Date(message.timestamp).toLocaleString()}
                        </p>
                      </div>
                      <button
                        onClick={() => deleteMessage(message)}
                        style={{
                          background: "red",
                          color: "white",
                          border: "none",
                          borderRadius: "4px",
                          padding: "4px",
                          cursor: "pointer",
                        }}
                      >
                        Delete
                      </button>
                    </div>
                  ) : (
                    <div style={{ display: "flex", alignItems: "center", gap: "12px" }}>
                      <div style={{ padding: "8px", backgroundColor: "#e5e7eb", borderRadius: "8px" }}>
                        <p>{message.text}</p>
                        <p style={{ fontSize: "0.875rem", color: "#6b7280" }}>
                          {new Date(message.timestamp).toLocaleString()}
                        </p>
                      </div>
                      <button
                        onClick={() => deleteMessage(message)}
                        style={{
                          background: "red",
                          color: "white",
                          border: "none",
                          borderRadius: "4px",
                          padding: "4px",
                          cursor: "pointer",
                        }}
                      >
                        Delete
                      </button>
                    </div>
                  )}
                </div>
              ))}
            </div>

            {/* Input */}
          </div>
        ) : (
          <p style={{ textAlign: "center", color: "#6b7280" }}>Select a room to start chatting</p>
        )}
      </div>
    </div>
  );
};

export default Chat;
